import ConfigProvider from '../Core/Configuration/ConfigProvider';
import BucketHelper from '../Core/Bucket/BucketHelper';
import LNStorage from '../Core/LocalStorage/LNStorage';

const WidgetId = 'li-nacion-recommended-item-template-1';

const LocalStorageKey = {
    HTML: 'TePuedeInteresar_HTML'
};

const Defaults = {
    max: 6,
    enableCaching: true,
    cachingSettings: {
        expirationTime: 5
    },
    enableTracking: true
};

export default class TePuedeInteresar {
    constructor(provider, options = {}) {
        if (!provider) {
            throw new Error('The "provider" parameter is required.');
        }

        this.registered = false;
        this.provider = provider;
        this.options = Object.assign({}, Defaults, options);
    }

    Load() {
        this.$module = document.querySelector('[data-module="TePuedeInteresar"]');

        if (this.$module === null)
            return;

        this._Fetch();
    }

    _Fetch() {
        this._Register();

        if (this.options.enableCaching) {
            const value = LNStorage.Get(LocalStorageKey.HTML);

            if (value) {
                this.$module.innerHTML = value;

                return;
            }
        }

        $p('fetch');
    }

    _Register() {
        const $component = this;

        if ($component.registered)
            return;

        $p('register', {
            widget: WidgetId,
            max: $component.options.max,
            callback: function (response) {
                $component._ProcessResponse(response);
                $component._Track();
            }
        });

        $component.registered = true;
    }

    _ProcessResponse(response) {
        const items = response.items;
        const quantity = Math.max(this.options.max, items.length);

        this.$module.innerHTML = _getTemplate(quantity);

        const $items = this._Items;
        const toiValue = this.provider.getToiValue();

        for (let i = 0; i < $items.length && i < items.length; ++i) {
            const item = items[i];
            const $itemPlaceHolder = $items[i];
            const $itemWrapper = document.createElement('div');

            item.data_pos = `toi${toiValue}`;

            item.image_1
                = item.image_2
                = BucketHelper.GetUrl(ConfigProvider.BucketUrl, item.image, 173, '', 'jpg');

            $itemWrapper.innerHTML = this._Render(item);
            $itemPlaceHolder.parentNode.replaceChild($itemWrapper.firstChild, $itemPlaceHolder);
        }

        if (this.options.enableCaching) {
            LNStorage.Set(LocalStorageKey.HTML, this.$module.innerHTML, this.options.cachingSettings.expirationTime);
        }
    }

    _Render(item) {
        return $p('render', _getItemTemplate(), item);
    }

    _Track() {
        if (!this.options.enableTracking)
            return;

        $p('track', {
            name: WidgetId,
            source: 'LI',
            elements: this._Items
        });
    }

    get _Items() {
        return this.$module.querySelectorAll('.nota');
    }
}

function _getTemplate(quantity) {
    return `
        <h4 class="titulo text-subrayado">
            Te puede interesar
        </h4>
        <section class="notas-container">
            ${_getItemPlaceHolderByQuantity(quantity)}
        </section>`;
}

function _getItemTemplate() {
    return `<article title="{{title}}" class="nota" data-pos="{{data_pos}}">
        <a class="figure" href="{{url}}">
            <picture>
                <source media="(min-width: 768px)" srcset="{{image_1}}" />
                <img src="{{image_2}}" />
            </picture>
        </a>
        <h2>
            <a href="{{url}}">{{title}}</a>
        </h2>
    </article>`;
}

function _getItemPlaceHolder() {
    return '<article class="nota"></article>';
}

function _getItemPlaceHolderByQuantity(quantity) {
    return _getItemPlaceHolder().repeat(quantity);
}


// WEBPACK FOOTER //
// ./Statics/scripts/Modules/TePuedeInteresar.js